import axiosInstance from "../../../api/axiosInstance";

export const fetchPhrases = async (params) => {
  try {
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    );
    console.log("[PhraseService] Fetching phrases, params:", cleaned);
    const res = await axiosInstance.get("/public/phrases", { params: cleaned });
    console.log("[PhraseService] Fetch phrases response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[PhraseService] Fetch phrases failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchPhraseById = async (id) => {
  try {
    console.log("[PhraseService] Fetching phrase by id:", id);
    const res = await axiosInstance.get(`/public/phrases/${id}`);
    console.log("[PhraseService] Fetch phrase by id response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[PhraseService] Fetch phrase by id failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};
